import { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { PiWarningFill } from "react-icons/pi";

function SubmitConfirmModal({ show, onCancel, onConfirm, allowMultipleSubmissions = false }) {
    const [inputValue, setInputValue] = useState("");

    const isConfirmEnabled = allowMultipleSubmissions || inputValue === "SUBMIT";

    const handleConfirm = () => {
        if (isConfirmEnabled) {
            setInputValue(""); // Reset input
            onConfirm();
        }
    };

    const handleCancel = () => {
        setInputValue(""); // Reset input
        onCancel();
    };

    return (
        <Modal
            show={show}
            onHide={handleCancel}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title className="d-flex align-items-center gap-2">
                    {!allowMultipleSubmissions && <PiWarningFill style={{ color: '#dc3545' }} />}
                    {allowMultipleSubmissions ? "Confirm Submission" : "Final Submission"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex flex-column gap-3">
                <p style={{ marginBottom: '0', color: '#333' }}>
                    {allowMultipleSubmissions
                        ? "Submit your current responses? You can continue editing and resubmit until the deadline."
                        : "This is your final submission. You will not be able to modify your responses after this."}
                </p>
                {!allowMultipleSubmissions && (
                    <Form.Group>
                        <Form.Label style={{ fontWeight: '500' }}>
                            Type <strong>SUBMIT</strong> to confirm
                        </Form.Label>
                        <Form.Control
                            type="text"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            placeholder="Type SUBMIT here"
                            autoComplete="off"
                        />
                    </Form.Group>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button
                    variant={allowMultipleSubmissions ? "success" : "danger"}
                    onClick={handleConfirm}
                    disabled={!isConfirmEnabled}
                >
                    {allowMultipleSubmissions ? "Submit" : "Submit"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SubmitConfirmModal;
